module.exports = __webpack_public_path__ + "static/media/detail_0008_f.fc50eca3.jpg";